import { PageContainer, Spinner } from "@shapr3d/frontend-lib";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";

import { OverlayProvider } from "../../components/Headers/components/ShareModal/components/MenuPortal";
import { ViewLinkList } from "../../components/ViewLinkList/ViewLinkList";
import { useGuardSyncOffTeams } from "../../hooks/useGuardSyncOffTeams";
import { useProjectViewLinkList } from "../../hooks/useProjectViewLink";
import useTranslation from "../../hooks/useTranslation";

import style from "./ViewLinkListPage.module.css";

function ViewLinkListPageComponent() {
  const { teamID } = useParams();
  useGuardSyncOffTeams({ enabled: true });

  const { data, isLoading, fetchNextPage, isFetchingNextPage, hasNextPage } =
    useProjectViewLinkList({
      teamId: teamID,
      latestByProject: true,
    });
  const { t, m } = useTranslation();

  if (isLoading) {
    return (
      <div className={style.pageContainer}>
        <Spinner />
      </div>
    );
  }

  return (
    <OverlayProvider>
      <PageContainer title={t(m.ViewLink.PageTitle)}>
        <ViewLinkList
          viewLinks={data?.projectViewLinks ?? []}
          users={data?.users ?? []}
          telemetryLocation="review_links"
          isUnpublishHidden
          fetchNextPage={fetchNextPage}
          isFetchingNextPage={isFetchingNextPage}
          hasNextPage={hasNextPage}
        />
      </PageContainer>
    </OverlayProvider>
  );
}

export default function ViewLinkListPage() {
  const { t, m } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t(m.ViewLink.DocumentTitle)}</title>
        <meta name="description" content={t(m.ViewLink.MetaDescription)} />
      </Helmet>
      <ViewLinkListPageComponent />
    </>
  );
}
